import {EventEmitter} from 'eventemitter3'

export const refReloadEvent = new EventEmitter()

export const RefReloadEventTypes = {
    DETAIL_INFORMATION: 'DETAIL_INFORMATION',
}

export function getRefReloadEventKey(eventType, id) {
    if (!id) {
        return ''
    }

    switch (eventType) {
        case RefReloadEventTypes.DETAIL_INFORMATION:
            return `DETAIL_INFORMATION_${id}`
        default:
            return ''
    }
}

export function onRefReloadListener(eventType, id) {
    if (!id) {
        return
    }

    refReloadEvent.emit(`${getRefReloadEventKey(eventType, id)}`)
}

export function removeRefReloadListener(eventType, id) {
    if (!id) {
        return
    }

    refReloadEvent.removeListener(`${getRefReloadEventKey(eventType, id)}`)
}
